<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" title="Glossary">
<p class="phead1" id="P4_1"><span class="right_1" epub:type="pagebreak" id="page_283" title="283"><a href="#/text/nav#rP4_1">G<span class="small">LOSSARY</span></a></span></p>
<p class="noindent"><i>ach:</i> oh</p>
<p class="noindent"><i>aenti:</i> aunt</p>
<p class="noindent"><i>appeditlich:</i> delicious</p>
<p class="noindent"><i>bedauerlich:</i> sad</p>
<p class="noindent"><i>boppli:</i> baby</p>
<p class="noindent"><i>brot:</i> bread</p>
<p class="noindent"><i>bruder:</i> brother</p>
<p class="noindent"><i>bruders:</i> brothers</p>
<p class="noindent"><i>bruderskinner:</i> nieces/nephews</p>
<p class="noindent"><i>bu:</i> boy</p>
<p class="noindent"><i>buwe:</i> boys</p>
<p class="noindent"><i>daadi:</i> grandfather</p>
<p class="noindent"><i>danki:</i> thank you</p>
<p class="noindent"><i>dat:</i> dad</p>
<p class="noindent"><i>dochder:</i> daughter</p>
<p class="noindent"><i>dochdern:</i> daughters</p>
<p class="noindent"><i>Dummle!:</i> Hurry!</p>
<p class="noindent"><i>fraa:</i> wife</p>
<p class="noindent"><i>freind:</i> friend</p>
<p class="noindent"><i>freinden:</i> friends</p>
<p class="noindent"><span class="right_1" epub:type="pagebreak" id="page_284" title="284"><i>froh:</i> happy</span></p>
<p class="noindent"><i>gegisch:</i> silly</p>
<p class="noindent"><i>gern gschehne:</i> you’re welcome</p>
<p class="noindent"><i>Gude mariye:</i> Good morning</p>
<p class="noindent"><i>gut:</i> good</p>
<p class="noindent"><i>Gut nacht:</i> Good night</p>
<p class="noindent"><i>haus:</i> house</p>
<p class="noindent"><i>Ich liebe dich:</i> I love you</p>
<p class="noindent"><i>kaffi:</i> coffee</p>
<p class="noindent"><i>kapp:</i> prayer covering or cap</p>
<p class="noindent"><i>kichli:</i> cookie</p>
<p class="noindent"><i>kichlin:</i> cookies</p>
<p class="noindent"><i>kinner:</i> children</p>
<p class="noindent"><i>krank:</i> ill</p>
<p class="noindent"><i>kuche:</i> cake</p>
<p class="noindent"><i>kuchen:</i> cakes</p>
<p class="noindent"><i>kumm:</i> come</p>
<p class="noindent"><i>liewe:</i> love, a term of endearment</p>
<p class="noindent"><i>maed:</i> young women, girls</p>
<p class="noindent"><i>maedel:</i> young woman</p>
<p class="noindent"><i>mamm:</i> mom</p>
<p class="noindent"><i>mammi:</i> grandmother</p>
<p class="noindent"><i>mei:</i> my</p>
<p class="noindent"><i>naerfich:</i> nervous</p>
<p class="noindent"><i>narrisch:</i> crazy</p>
<p class="noindent"><i>oncle:</i> uncle</p>
<p class="noindent"><i>schee:</i> pretty</p>
<p class="noindent"><i>schmaert:</i> smart</p>
<p class="noindent"><i>schtupp:</i> family room</p>
<p class="noindent"><i>schweschder:</i> sister</p>
<p class="noindent"><i>schweschdere:</i> sisters</p>
<p class="noindent"><i>sohn:</i> son</p>
<p class="noindent"><span class="right_1" epub:type="pagebreak" id="page_285" title="285"><i>Was iss letz?:</i> What’s wrong?</span></p>
<p class="noindent"><i>Wie geht’s:</i> How do you do? or Good day!</p>
<p class="noindent"><i>wunderbaar:</i> wonderful</p>
<p class="noindent"><i>ya:</i> yes</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780310354369_Glossary_P4.vue?41919a8e